import { Loading} from 'element-ui';


export default {
    debounce(fn, t, el) {
        let delay = t || 500;
        let timer;
        return function() {
          let args = arguments;
          if (timer) {
            clearTimeout(timer);
          }
    
          let callNow = !timer;
    
          timer = setTimeout(() => {
            timer = null;
          }, delay);
    
          // START --> 在元素上显示loading
          if(el) {
            let debouLoading = Loading.service({
              body: false, // 将loading插入在body上，而不是dom上；启用会变漂亮，但是移动页面会出现loading滞留在原位置的情况
              customClass: 'debou-loading',
              target: el // this
            })
            el.disabled = true;
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.5';
            setTimeout(() => {
              debouLoading.close();
              el.disabled = false;
              el.style.pointerEvents = 'auto';
              el.style.opacity = '1';
            }, t);
          }
          // <-- END
    
          if (callNow) fn.apply(this, args);
        };
      }
}


// WEBPACK FOOTER //
// ./src/library/antiShakeTool.js